import { inject, Pipe, PipeTransform } from '@angular/core';
import { WorkflowOptionSetService } from '../services/workflow-option-set.service';

@Pipe({
    name: 'isFieldLoading',
    standalone: true,
    pure: false
})
export class IsFieldLoadingPipe implements PipeTransform {
    private workflowOptionSetService = inject(WorkflowOptionSetService);

    transform(fieldName: string): boolean {
        return this.workflowOptionSetService.isFieldLoading(fieldName) ?? false;
    }
}
